<template>
  <div>
    <breadcrumb v-bind:path2="path2"></breadcrumb>
    <div class="contact">
      <div class="main-content">
        <div class="page-width">
          <div class="section-header text-center">
            <h1>{{ $t('contact') }}</h1>
          </div>
          <p v-if="submit" class="success-message" tabindex="-1" data-form-status="success">{{ $t('thankContact') }}
          </p>
          <div class="contact-form form-vertical">
            <el-form :label-position="labelPosition"  ref="contactForm" :model="contactForm" class="demo-form-inline"  >
              <el-form-item v-bind:label="$t('contactName')+'*'" >
                <el-input :class="error.name ? 'el-input-error' : ''" v-model="contactForm.Name"></el-input>
                <span v-if="error.name" class='error-message'>
                  <svg class="icon icon-error">
                    <path
                      d="M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14zm-1.05-3.85A1.05 1.05 0 1 1 7 11.2a1.008 1.008 0 0 1-1.05-1.05zm.381-1.981l-.266-5.25h1.841l-.255 5.25h-1.32z"></path>
                  </svg>
                  {{error.name}}
                </span>
              </el-form-item>
              <el-form-item v-bind:label="$t('contactEmail')+'*'">
                <el-input :class="error.email ? 'el-input-error' : ''" v-model="contactForm.Email"></el-input>
                <span v-if="error.email" class='error-message'>
                  <svg class="icon icon-error">
                    <path
                      d="M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14zm-1.05-3.85A1.05 1.05 0 1 1 7 11.2a1.008 1.008 0 0 1-1.05-1.05zm.381-1.981l-.266-5.25h1.841l-.255 5.25h-1.32z"></path>
                  </svg>
                  {{error.email}}
                </span>
              </el-form-item>
              <el-form-item v-bind:label="$t('phoneNumber')">
                <el-input v-model="contactForm.PhoneNumber"></el-input>
              </el-form-item>
              <el-form-item v-bind:label="$t('contactMessage')+'*'">
                <el-input :class="error.message ? 'el-input-error' : ''" type="textarea" :rows="10" v-model="contactForm.Message"></el-input>
                <span v-if="error.message" class='error-message'>
                  <svg class="icon icon-error">
                    <path
                      d="M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14zm-1.05-3.85A1.05 1.05 0 1 1 7 11.2a1.008 1.008 0 0 1-1.05-1.05zm.381-1.981l-.266-5.25h1.841l-.255 5.25h-1.32z"></path>
                  </svg>
                  {{error.message}}
                </span>
              </el-form-item>
              <!-- <div class="icon">
                <div class="contact-icons">
                  <div class="wechat_customer">
                    <span>{{ $t('contactWechat') }}</span>
                    <div class="contact-icons__link">
                      <div class="contact_icon_hover">
                        <div class="contact_hover_inr">
                          <img src="../../assets/img/Wechat_Customer_Service.png">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
              <el-button class="btn m-1" @click="onSubmit(contactForm)">{{ $t('submit') }}</el-button>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import breadcrumb from '../../components/breadcrumb'
import { validateEmail } from "../../../config/validation";

export default {
  name: "contact",
  components: {
    breadcrumb,
  },
  data(){
    return{
      submit: false,
      error:{
        name: '',
        email: '',
        message: '',
      },
      contactForm:{
        Name:'',
        Email:'',
        PhoneNumber:'',
        Message:'',
      },
      labelPosition:'top',//form alignment
      path2: this.$t('contact'),
    }
  },
  methods:{
    ...mapActions('contact', ['postContact']),
    async checkForm(form) {
      if (!form.Name){
        this.error.name = 'Name is invalid.'
      };
      if (validateEmail(form.Email)){
        this.error.email = 'Email is invalid.'
      };
      if (!form.Message){
        this.error.message = 'Message cannot be empty.'
      };
    },
    onSubmit(form){
      this.submit = false;
      this.checkForm(form);
      if (!this.error.length) {
        this.$store.dispatch('contact/postContact', form);
      }
    },
  },
  computed: mapState({ postContactSuccess: state => state.contact.postContactSuccess, }),
  watch: {
    postContactSuccess(newValue, oldValue) {
      if (newValue == true) {
        this.submit = true;
        this.contactForm.Name = '';
        this.contactForm.Email = '';
        this.contactForm.PhoneNumber = '';
        this.contactForm.Message = '';
      }
    },
    $route() {
      this.$router.go(this.$route);
    }
  }
}
</script>

<style scoped lang="less">
@import "../../assets/css/public.less";
@import "../../assets/css/contact.less";
</style>



// WEBPACK FOOTER //
// src/view/Footer/contact.vue